<template>
  <LayoutGradient :title="this.$t('reportTrash.form.titulo_pagina.editar')" icon="fa-trash">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.push({ name: 'vns.report_trash'})">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">      
      <b-form @submit="onSubmit">
        <b-form-group
          :label="$t('reportTrash.form.fields.vns.label')"
          label-for="input-vns"
          :description="$t('reportTrash.form.fields.vns.description')"
        >
          <b-overlay :show="store_vnss_loading">
            <SelectComponent
                  id="input-vns"
                  :model="vns"
                  :options="store_vnss | idNameToValueLabel"
                  @search="evt => {autocomplete('vns', evt)}"
                  @input="evt => reloadPage(evt)"
              />
          </b-overlay>
        </b-form-group>
        <b-form-group
          :label="$t('reportTrash.form.fields.report_trash.label')"
          label-for="input-report-trash"
          :description="$t('reportTrash.form.fields.report_trash.description')"
        >
          <b-input-group>
            <b-input-group-prepend>
              <b-button
                  variant="outline-success"
                  @click="addElement('addVnsReportTrash', {id: null, name: inputReportTrash})">
                <i class="fas fa-plus"/></b-button>
            </b-input-group-prepend>
            <b-form-input id="input-report-trash" v-model="inputReportTrash" @keydown.enter.prevent="" @keyup.enter="addElement('addVnsReportTrash', {id: null, name: inputReportTrash})"/>
          </b-input-group>
          <b-table v-if="trashs && trashs.length > 0"
                    thead-class="d-none"
                    :fields="['id','name']"
                    :items="trashs"
                    tbody-tr-class="float-left">
            <template v-slot:cell(id)="linha">
              <b-button
                  variant="outline-danger"
                  @click="removeElement('addVnsReportTrash', linha.item); removeElementDb('reportTrashs', linha.item);"
                  pill><i class="fas fa-minus"/>
              </b-button>
            </template>
          </b-table>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('reportTrash.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ReportTrashRepository from '@/repositories/vns/ReportTrashRepository'
import SelectComponent from "@/components/SelectComponent";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient,
    SelectComponent
  },
  data() {
    return {
      vnsId: null,
      addVnsReportTrash: [],
      inputReportTrash: ''
    }
  },
  computed: {
    ...mapGetters({
      reportTrashs: 'reportTrash/allByVns',
      isLoading: 'reportTrash/isLoading',
      store_vnss: 'vns/all',
      store_vnss_loading: 'vns/isLoading',
    }),
    vns() {
      if (this.vnsId && this.store_vnss) {
        const model = this.store_vnss.find(c => this.vnsId === c.id)
        if (model) {
          return {
            value: model.id,
            label: model.name
          }
        }        
      }
      return {}
    },
    trashs() {
      let vnsReportTrash =  this.reportTrashs.vnsReportTrash.map((trash) => {
        return {          
          id: trash.id,
          name: trash.report_trash
        }
      });

      return vnsReportTrash.concat(this.addVnsReportTrash);
    }
  },
  methods: {
    ...mapActions([
      'reportTrash/listByVns',
      'vns/listAll',
      'vns/search'
    ]),
    async reloadPage(evt) {
      this.vnsId = evt.value;
      this.addVnsReportTrash = [];
      this.inputReportTrash = '';
      this.$router.push({ name: 'vns.report_trash.edit', params: { id: evt.value } });      
      await this['reportTrash/listByVns'](this.vnsId)
    },
    addElement(array, element) {
      this[array] = [...this[array], element];
      this.inputReportTrash = '';
    },
    removeElement(array, element) {
      this[array] = this[array].filter(e => {
        return e !== element
      })
    },
    removeElementDb(array, element) {
      this[array].vnsReportTrash = this[array].vnsReportTrash.filter(e => {
        return e.report_trash !== element.name
      })
    },
    async onSubmit(evt) {
      evt.preventDefault()
      this.update()
    },
    update() {
      ReportTrashRepository.postByVns(this.vnsId, {trashs: this.trashs.map(t => {return t.name;})}).then(response => {
        this.$snotify.success(this.$t('reportTrash.form.update.success'))
        this.$router.push({name: 'vns.report_trash'})
      }).catch(error => {
        this.$snotify.error(this.$t('reportTrash.form.update.error'))
        if (error.response.status === 422) {
          ReportTrashRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array, ['status', '=', true]]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    temporallyStringPrepareToSQL(field, valueTyped) {
      return [
        [field, 'LIKE', '%' + valueTyped + '%']        
      ];
    }
  },
  async mounted() {
    await this['reportTrash/listByVns'](this.$route.params.id)
    await this['vns/listAll']()
    this.vnsId = this.$route.params.id    
  }
}
</script>

<style lang="scss" scoped>
</style>
